import { Component } from '@angular/core';

@Component({
  templateUrl: './framed-page.component.html',
})
/**
 * Framed page
 */
export class FramedPage {}
